import { kebabCase } from 'lodash-es';

import { Box, Heading } from '@chakra-ui/react';
import { headerHeight } from '@udacity/udacity-header-v2';

import { Markdown } from '~/components/markdown';

export function TitleMarkdownSection({ title, body }: { title: string; body: string }) {
  const id = kebabCase(title);
  return (
    <Box
      position='relative'
      _notLast={{
        '&::after': {
          content: '""',
          display: {
            base: 'block',
            md: 'none',
          },
          borderTop: '1px solid',
          position: 'absolute',
          bottom: '-24px',
          left: 0,
          right: 0,
          borderColor: 'accent.sky.500',
          opacity: 0.2,
        },
      }}
    >
      <Heading
        as='h3'
        id={id}
        mb={3}
        scrollMarginTop={`calc(${headerHeight} + 16px)`}
        size={{
          base: 'marketing-2xl',
          md: 'marketing-3xl',
        }}
      >
        {title}
      </Heading>
      <Markdown markdownText={body} />
    </Box>
  );
}
